import React from 'react';

import { Button } from '@mui/material';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button/Button';

import classes from './ProjectContractFilterButton.module.scss';

interface Props extends MuiButtonProps {
    value: string | undefined;
}

export const ProjectContractFilterButton = ({ value, ...props }: Props) => {
    return (
        <div className={classes.ProjectContractFilterButton}>
            <Button className={classes.button} variant={'outlined'} {...props}>
                <span className={classes.label}>{value}</span>
            </Button>
        </div>
    );
};
